// Shared Category tag colors so "Direct" / "Indirect" / "Other/Fixed" render identically
// across every Crewing Analytics table (Location, Hours, Employee, etc.).
export const CATEGORY_TAG_STYLES: Record<string, { backgroundColor: string; color: string }> = {
  direct: { backgroundColor: '#DCE9FC', color: '#0B5FC6' },
  indirect: { backgroundColor: '#EDEFF2', color: '#4B5563' },
  'other/fixed': { backgroundColor: '#FEF3C7', color: '#B45309' },
  other: { backgroundColor: '#FEF3C7', color: '#B45309' },
};

export const DEFAULT_CATEGORY_TAG_STYLE = { backgroundColor: '#F0F0F0', color: '#4B4B4B' };

// Tag colors are applied inline (not via StyleSheet), so the global dark-mode stylesheet sweep
// never reaches them while all text is forced white — dark variants need solid dark fills.
export const CATEGORY_TAG_STYLES_DARK: Record<string, { backgroundColor: string; color: string }> = {
  direct: { backgroundColor: '#1B3A66', color: '#FFFFFF' },
  indirect: { backgroundColor: '#3A3F47', color: '#FFFFFF' },
  'other/fixed': { backgroundColor: '#92600A', color: '#FFFFFF' },
  other: { backgroundColor: '#92600A', color: '#FFFFFF' },
};

export const DEFAULT_CATEGORY_TAG_STYLE_DARK = { backgroundColor: '#3A3A3A', color: '#FFFFFF' };

export const getCategoryTagStyle = (value: string, isDark: boolean = false) =>
  isDark
    ? CATEGORY_TAG_STYLES_DARK[value.toLowerCase()] ?? DEFAULT_CATEGORY_TAG_STYLE_DARK
    : CATEGORY_TAG_STYLES[value.toLowerCase()] ?? DEFAULT_CATEGORY_TAG_STYLE;
